<template>
  <div>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <b-col cols="12" class="mb-1">
          <div class="d-flex align-items-center justify-content-end">
            <b-button @click="exportToExcel(
                participants,
                ['NIK', 'Name', 'Divisi', 'Acara', 'Pembicara', 'Materi', 'Kritik', 'Saran', 'Waktu'],
                ['nik', 'name', 'division', 'event_rate', 'speaker_rate', 'material_rate', 'criticsm', 'suggestion', 'created_at'],
                ['PCC Rating'],
                formatJson
              )" variant="primary"
              >Export Excel</b-button
            >
          </div>
        </b-col>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-start mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="mr-1 per-page-selector d-inline-block ml-50"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
        >
          <label class="mr-1">
            Search
          </label>
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              class="d-inline-block"
              placeholder="Search..."
              v-model="searchWord"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Larger screen than mobile -->
    <div class="d-none d-md-flex">
      <b-table
        class="w-100 border"
        responsive
        striped
        :items="participants"
        :fields="fields"
      />
    </div>
    <!-- Mobile screen -->
    <div class="d-flex d-md-none flex-column">
      <!-- Loading -->
      <div v-if="isBusy" class="text-center text-danger my-2">
        <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
        <strong class="text-secondary">Loading...</strong>
      </div>
      <!-- Data -->
      <div v-if="!isBusy && participants.length == 0" class="text-center text-danger my-2">
        <strong class="text-secondary">No data</strong>
      </div>
      <b-row
        v-if="!isBusy && participants.length > 0"
        v-for="(item, index) in participants"
        :key="item.id"
        class="mb-3 list-item"
      >
        <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
          <strong class="flex-grow-1 truncate">{{ item.user.nik }}</strong>
        </b-col>
        <b-col cols="12" class="d-flex flex-wrap">
          <div style="font-size: 0.75rem;">
            <p><strong>NAME: </strong>{{ item.user.name }}</p>
            <p><strong>DIVISI: </strong>{{ item.user.division }}</p>
            <p><strong>ACARA: </strong>{{ item.event_rate }}</p>
            <p><strong>PEMBICARA: </strong>{{ item.speaker_rate }}</p>
            <p><strong>MATERI: </strong>{{ item.material_rate }}</p>
            <p><strong>KRITIK: </strong>{{ item.criticsm }}</p>
            <p><strong>SARAN: </strong>{{ item.suggestion }}</p>
            <p><strong>DATE: </strong>{{ $moment(item.created_at).format('lll') }}</p>
          </div>
        </b-col>
      </b-row>
    </div>

    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            Showing {{ pagination.from }} to {{ pagination.to }} of
            {{ pagination.total }} entries
          </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            @input="changePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import VSelect from 'vue-select'
import {
  BRow,
  BCol,
  BPagination,
  BTable,
  BFormInput,
  BButton,
} from 'bootstrap-vue'

export default {
  components: { BRow, BCol, BPagination, BTable, BFormInput, VSelect, BButton },

  props: ['pccId'],

  data() {
    return {
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      searchWord: '',

      participants: [],
      fields: [
        { key: 'user.nik', label: 'NIK' },
        { key: 'user.name', label: 'Name' },
        { key: 'user.division', label: 'Divisi' },
        { key: 'event_rate', label: 'Acara' },
        { key: 'speaker_rate', label: 'Pembicara' },
        { key: 'material_rate', label: 'Materi' },
        { key: 'criticsm', label: 'Kritik' },
        { key: 'suggestion', label: 'Saran' },
        {
          key: 'created_at',
          formatter: (value, key, item) => {
            return this.$moment(value).format('lll')
          },
          label: 'Date',
          sortable: true,
        },
      ],
    }
  },

  watch: {
    perPage() {
      this.fetchPCCParticipants()
    },
    currentPage() {
      this.fetchPCCParticipants()
    },
    searchWord(newVal) {
      this.searchParticipant()
    },
    pccId() {
      this.fetchPCCParticipants()
    },
  },

  mounted() {
    this.fetchPCCParticipants()
  },

  methods: {
    changePage(page) {
      this.currentPage = page
    },

    fetchPCCParticipants() {
      if (this.pccId) {
        this.isBusy = true

        this.$http
          .get(`/pcc/rating-detail/${this.pccId}`, {
            params: {
              page: this.currentPage,
              perPage: this.perPage,
              s: this.searchWord.toString().trim(),
              // sort: `${this.sortDesc ? '-' : ''}${this.sortBy}`,
            },
          })
          .then(({ data }) => {
            this.currentPage = data.current_page
            this.pagination.total = data.total
            this.pagination.from = data.from
            this.pagination.to = data.to
            this.participants = data.data
          })
          .finally(() => {
            this.isBusy = false
          })
      }
    },

    searchParticipant: debounce(function() {
      this.fetchPCCParticipants()
    }, 200),

    exportPDF() {
      window.open(
        `${process.env.VUE_APP_API_HOST}/api/pdf/participants/pcc/${this.pccId}`,
        '_blank'
      )
    },
    exportToExcel (records, headers, fieldVal, filename, formatJson) {
      import('@/libs/Export2Excel').then(excel => {
          const list = records
          const data = formatJson(fieldVal, list)
          excel.export_json_to_excel({
            header: headers,
            data,
            filename,
            autoWidth: true,
            bookType: 'xlsx'
          })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        let data = null
        data = v[j]

        if (j === 'nik') {
          data = v.user.nik
        }

        if (j === 'name') {
          data = v.user.name
        }
        
        if (j === 'division') {
          data = v.user.division
        }
        
        if (j === 'created_at') {
          data = this.$moment(v.created_at).format('lll')
        }

        return data
      }))
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
